import { render, staticRenderFns } from "./Barplot2.vue?vue&type=template&id=2175b3b0&scoped=true&"
import script from "./Barplot2.vue?vue&type=script&lang=js&"
export * from "./Barplot2.vue?vue&type=script&lang=js&"
import style0 from "./Barplot2.vue?vue&type=style&index=0&id=2175b3b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175b3b0",
  null
  
)

export default component.exports